import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, NgZone, inject } from '@angular/core';
import { PopupService } from '../../services/popup.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-popup-host',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-popup-host.component.html',
  styleUrl: './app-popup-host.component.css'
})
export class AppPopupHostComponent {
  popup = inject(PopupService);
  private cdr = inject(ChangeDetectorRef);
  private zone = inject(NgZone);

  state = this.popup.state;

  constructor() {
    this.popup.state$
      .pipe(takeUntilDestroyed())
      .subscribe((s) => {
        this.zone.run(() => {
          this.state = s;
          this.cdr.markForCheck();
        });
      });
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    const state = this.state;
    if (!state) return;

    if (state.type === 'confirm') {
      this.popup.cancelAction();
      return;
    }

    this.popup.close(true);
  }

  onOverlayClick(): void {
    const state = this.state;
    if (!state) return;

    if (state.type === 'confirm') {
      this.popup.cancelAction();
      return;
    }

    this.popup.close(true);
  }

  get iconClass(): string {
    const type = this.state?.type;
    if (type === 'success') return 'bi-check-circle-fill';
    if (type === 'error') return 'bi-x-circle-fill';
    return 'bi-question-circle-fill';
  }
}
